module.exports = "/static/assets/ce4c8734aa6e76ab82c03bbe3488b8c1.png";